module.exports = __webpack_public_path__ + "static/media/door-open.ba817400.mp3";